import { render, staticRenderFns } from "./CardBees.vue?vue&type=template&id=1b10c558&"
import script from "./CardBees.vue?vue&type=script&lang=js&"
export * from "./CardBees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports